module.exports = __webpack_public_path__ + "static/media/cheveron.805d74c0.svg";